import { Badge, type BadgeTone } from "@/components/ui/badge";
import type { HzzStatus } from "@/lib/hzz";

const tones: Record<string, BadgeTone> = { green: "ok", blue: "info", amber: "warn", red: "bad", gray: "neutral" };
export function HzzStatusBadge({ code, statuses, review = false }: { code: string | null; statuses: HzzStatus[]; review?: boolean }) {
  const status = statuses.find(item => item.code === code);
  return <Badge tone={review || !status ? "warn" : tones[status.color] ?? "warn"}>{status?.name_hr ?? "Status nije poznat · provjeriti"}</Badge>;
}
